import React from "react"

function ReferenceNotice() {
  return (
    <div className="bg-yellow-300 py-6 px-4">
      <div className="container mx-auto px-3 leading-tight">
        <h3 className="text-lg font-bold mb-3">Action Required</h3>

        <p className="m-0 mb-1">
          As per the membership guidelines you are required to provide{" "}
          <b>two references</b> from current members of the BSSR (current
          colleagues or former trainers). To request a reference from one of our
          members please search for your referees in the fields below.
        </p>
      </div>
    </div>
  )
}

export default ReferenceNotice
